module.exports = __webpack_public_path__ + "img/the-fifth-season.df50f2bb.png";